export default __webpack_public_path__ + "static/media/project_wmobil_blur.21ac4748.png";